import { createSearchPreFilters } from '@shared/composables/useSearchPreFilters';

import composableConfig from '~/config/composableConfig';
import { searchPreFiltersConfig } from '~/config/searchPreFilters';
import {
  BASE_SEARCH_PATH,
  HIDDEN_PRODUCT_TAG,
  SEARCH_CATEGORY_TENANT_PREFIX,
  SEARCH_DEFAULT_TITLE_OPTION,
  SEARCH_QUERY_PARAM,
} from '~/constants';

export const useSearchPreFilters = createSearchPreFilters({
  config: searchPreFiltersConfig,
  facetMaps: composableConfig.useProductListingSearch?.facetMaps ?? {},
  constants: {
    BASE_SEARCH_PATH,
    HIDDEN_PRODUCT_TAG,
    SEARCH_CATEGORY_TENANT_PREFIX,
    SEARCH_DEFAULT_TITLE_OPTION,
    SEARCH_QUERY_PARAM,
  },
});
